import PageContainer from '@/common/components/PageContainer'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { useParams } from 'react-router-dom'
import useQueryGetCoupons from '../../api/hooks/useQueryGetCoupons'
import { Card, CardContent, CardHeader, CardTitle } from '@/common/ui/card'
import CouponTable from '../../components/CouponTable'
import NavigateBackButton from '@/common/components/NavigateBackButton'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function BatchCouponsPage() {
	const { id } = useParams<{ id: string }>()
	const { pageSize, currentPage, searchQuery, selectedQuery } =
		useTablePagination()

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		batchId: id,
		status: selectedQuery as 'USED' | 'ACTIVE' | 'EXPIRED' | undefined,
		code: searchQuery,
	}

	const { data, isLoading } = useQueryGetCoupons(payload)

	return (
		<PageContainer>
			<Card>
				<CardHeader className="flex flex-row items-center justify-between">
					<div className="space-y-1.5">
						<CardTitle>คูปอง</CardTitle>
					</div>
					<NavigateBackButton />
				</CardHeader>
				<CardContent>
					<CouponTable
						data={data?.data || []}
						total={data?.total || 0}
						isLoading={isLoading}
					/>
				</CardContent>
			</Card>
		</PageContainer>
	)
}

const GuardedBatchCouponsPage = withUserPermission(BatchCouponsPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_COUPON],
})

export default GuardedBatchCouponsPage
